import React from "react"
import autobind from "class-autobind"
import { Checkbox } from "material-ui"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate } from "../../../models"
import moment from "moment"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import { grey700 } from "material-ui/styles/colors"
interface IProps {
    availableDays: ISchedulePatternTemplate[]
    // fixed day is checked always
    fixedDay: ISchedulePatternTemplate
    selectedDays: ISchedulePatternTemplate[]
    handleSelectDays(selectedDays: ISchedulePatternTemplate[]): void
}
interface IState {
    selectedDays: ISchedulePatternTemplate[]
}

export default class AssignEmployeeSelectDays extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedDays: props.selectedDays,
        }
        autobind(this)
    }

    handleSelectDays(selectedDays) {
        this.setState({ selectedDays })
        this.props.handleSelectDays(selectedDays)
    }

    render() {
        return (
            <div style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: 5, color: grey700 }}>
                    {this.props.availableDays.length === 1 ?
                        moment(scheduleHelper.getTimeFromSimpleTime(scheduleHelper.getStartEndSimpleTimeOfPatternTemplate(this.props.availableDays[0]).StartSimpleTime)).format("ddd MMM. DD, YYYY") :
                        strings.Available_Days
                    }
                </div>
                {this.props.availableDays.length > 1 &&
                    <div>
                        <Checkbox
                            data-intercom-target={"AssignEmployee-Check-AllDays"}
                            label={strings.All_Days}
                            style={{ width: 100 }}
                            labelStyle={{ width: null }}
                            iconStyle={{ marginRight: 5 }}
                            checked={this.state.selectedDays.length === this.props.availableDays.length}
                            onCheck={(e, value) => this.handleSelectDays(value ? this.props.availableDays : [this.props.fixedDay])}
                        />
                        {new Array(Math.ceil(this.props.availableDays.length / 7)).fill("").map((divRow, divIndex) =>
                            <div key={divIndex}>
                                {new Array(7).fill("").map((row, index) => {
                                    const dayIndex = divIndex * 7 + index
                                    const day = this.props.availableDays[dayIndex]
                                    return dayIndex < this.props.availableDays.length &&
                                        <Checkbox
                                            key={dayIndex}
                                            checked={this.state.selectedDays.find(item => item.Id === day.Id) !== undefined}
                                            disabled={this.props.fixedDay.Id === day.Id}
                                            label={moment(scheduleHelper.getTimeFromSimpleTime(scheduleHelper.getStartEndSimpleTimeOfPatternTemplate(day).StartSimpleTime)).format("ddd DD")}
                                            onCheck={(e, checked) => {
                                                let selectedDays = this.state.selectedDays.slice()
                                                if (checked) {
                                                    !selectedDays.find(item => item.Id === day.Id) && selectedDays.push(day)
                                                }
                                                else {
                                                    selectedDays = selectedDays.filter(item => item.Id !== day.Id)
                                                }
                                                this.handleSelectDays(selectedDays)
                                            }}
                                            iconStyle={{ marginRight: 5 }}
                                            style={{ width: 85, marginRight: 10, display: "inline-block" }}
                                            labelStyle={{ width: null }}
                                        />
                                })}
                            </div>
                        )}
                    </div>
                }
            </div>
        )
    }
}
